import { useTranslation } from "react-i18next";
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeftIcon, InfoIcon, ExternalLinkIcon } from 'lucide-react';
export function VampDetail() {
  const {
    t
  } = useTranslation("analytics");
  const navigate = useNavigate();
  const [showFraudTooltip, setShowFraudTooltip] = useState(false);
  const [showCardTestingTooltip, setShowCardTestingTooltip] = useState(false);
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return <div className="max-w-7xl mx-auto" data-id="element-2570">
      {/* Breadcrumb */}
      <div className="mb-6" data-id="element-2571">
        <button onClick={() => navigate('/card-monitoring')} className="flex items-center gap-2 text-sm text-blue-600 hover:text-blue-700" data-id="element-2572">
          
          <ChevronLeftIcon size={16} data-id="element-2573" />
          <span data-id="element-2574">{t("pages.CardMonitoringPrograms.card_monitoring_programs")}</span>
        </button>
      </div>

      {/* Header */}
      <div className="mb-8" data-id="element-2575">
        <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-2576">
          {t("pages.CardMonitoringPrograms.visa_acquirer_monitoring_program_vamp")}
        </h1>
        <p className="text-gray-600" data-id="element-2577">
          {t("pages.VampDetail.view_your_monitoring_program_status_and")}
        </p>
      </div>

      {/* History Section */}
      <div className="mb-12" data-id="element-2578">
        <div className="flex items-center gap-2 mb-2" data-id="element-2579">
          <h2 className="text-lg font-semibold text-gray-900" data-id="element-2580">{t("pages.VampDetail.history")}</h2>
          <button className="text-gray-400 hover:text-gray-600" data-id="element-2581">
            <InfoIcon size={16} data-id="element-2582" />
          </button>
        </div>
        <p className="text-sm text-gray-600 mb-6" data-id="element-2583">
          {t("pages.VampDetail.your_program_history_for_the_last")}
        </p>

        {/* History Table */}
        <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-2584">
          <table className="w-full" data-id="element-2585">
            <thead className="bg-gray-50 border-b border-gray-200" data-id="element-2586">
              <tr data-id="element-2587">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider" data-id="element-2588">
                  {t("pages.VampDetail.program_type")}
                </th>
                {months.map(month => <th key={month} className="px-4 py-3 text-center text-xs font-medium text-gray-700 uppercase tracking-wider" data-id="element-2589">
                  
                    {month}
                  </th>)}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-2590">
              {/* Fraud and disputes row */}
              <tr className="hover:bg-gray-50" data-id="element-2591">
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-2592">
                  <div className="flex items-center gap-2" data-id="element-2593">
                    <span className="text-sm text-gray-900" data-id="element-2594">
                      {t("pages.VampDetail.fraud_and_disputes")}
                    </span>
                    <div className="relative" data-id="element-2595">
                      <button onMouseEnter={() => setShowFraudTooltip(true)} onMouseLeave={() => setShowFraudTooltip(false)} className="text-gray-400 hover:text-gray-600" data-id="element-2596">
                        
                        <InfoIcon size={14} data-id="element-2597" />
                      </button>
                      {showFraudTooltip && <div className="absolute left-full ml-2 top-1/2 -translate-y-1/2 z-10 w-64 p-3 bg-gray-900 text-white text-xs rounded-lg shadow-lg whitespace-normal" data-id="element-2598">
                          {t("pages.VampDetail.measures_fraud_and_disputes_against_the")}
                          <div className="absolute right-full top-1/2 -translate-y-1/2 border-8 border-transparent border-r-gray-900" data-id="element-2599"></div>
                        </div>}
                    </div>
                  </div>
                </td>
                {months.map((month, index) => <td key={month} className="px-4 py-4 text-center" data-id="element-2600">
                    {index === 11 ? <div className="flex justify-center" data-id="element-2601">
                        <div className="animate-spin h-4 w-4 border-2 border-gray-300 border-t-blue-600 rounded-full" data-id="element-2602"></div>
                      </div> : <div className="flex justify-center" data-id="element-2603">
                        <div className="w-3 h-3 bg-gray-300 rounded-full" data-id="element-2604"></div>
                      </div>}
                  </td>)}
              </tr>

              {/* Card testing row */}
              <tr className="hover:bg-gray-50" data-id="element-2605">
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-2606">
                  <div className="flex items-center gap-2" data-id="element-2607">
                    <span className="text-sm text-gray-900" data-id="element-2608">{t("pages.VampDetail.card_testing")}</span>
                    <div className="relative" data-id="element-2609">
                      <button onMouseEnter={() => setShowCardTestingTooltip(true)} onMouseLeave={() => setShowCardTestingTooltip(false)} className="text-gray-400 hover:text-gray-600" data-id="element-2610">
                        
                        <InfoIcon size={14} data-id="element-2611" />
                      </button>
                      {showCardTestingTooltip && <div className="absolute left-full ml-2 top-1/2 -translate-y-1/2 z-10 w-64 p-3 bg-gray-900 text-white text-xs rounded-lg shadow-lg whitespace-normal" data-id="element-2612">
                          {t("pages.VampDetail.measures_card_testing_against_the_total")}
                          <div className="absolute right-full top-1/2 -translate-y-1/2 border-8 border-transparent border-r-gray-900" data-id="element-2613"></div>
                        </div>}
                    </div>
                  </div>
                </td>
                {months.map((month, index) => <td key={month} className="px-4 py-4 text-center" data-id="element-2614">
                    {index === 11 ? <div className="flex justify-center" data-id="element-2615">
                        <div className="animate-spin h-4 w-4 border-2 border-gray-300 border-t-blue-600 rounded-full" data-id="element-2616"></div>
                      </div> : <div className="flex justify-center" data-id="element-2617">
                        <div className="w-3 h-3 bg-gray-300 rounded-full" data-id="element-2618"></div>
                      </div>}
                  </td>)}
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Historical and current program status */}
      <div className="mb-12" data-id="element-2619">
        <div className="flex items-center gap-2 mb-2" data-id="element-2620">
          <h2 className="text-lg font-semibold text-gray-900" data-id="element-2621">
            {t("pages.VampDetail.historical_and_current_program_status")}
          </h2>
          <button className="text-gray-400 hover:text-gray-600" data-id="element-2622">
            <InfoIcon size={16} data-id="element-2623" />
          </button>
        </div>
        <p className="text-sm text-gray-600 mb-6" data-id="element-2624">
          {t("pages.VampDetail.visaidentified_fraud_and_disputes_against_the")}
        </p>

        <div className="bg-white border border-gray-200 rounded-lg p-8" data-id="element-2625">
          <p className="text-center text-gray-500" data-id="element-2626">{t("pages.VampDetail.no_past_history_found")}</p>
        </div>
      </div>

      {/* Estimated program status */}
      <div className="mb-12" data-id="element-2627">
        <div className="flex items-center gap-2 mb-2" data-id="element-2628">
          <h2 className="text-lg font-semibold text-gray-900" data-id="element-2629">
            {t("pages.VampDetail.estimated_program_status")}
          </h2>
          <button className="text-gray-400 hover:text-gray-600" data-id="element-2630">
            <InfoIcon size={16} data-id="element-2631" />
          </button>
        </div>
        <p className="text-sm text-gray-600 mb-6" data-id="element-2632">
          {t("pages.VampDetail.pomelos_estimate_of_your_visa_frauds")}{' '}
          <a href="#" className="text-blue-600 hover:text-blue-700 underline" data-id="element-2633">
            {t("pages.CardMonitoringPrograms.learn_more")}
          </a>{' '}
          {t("pages.VampDetail.about_how_to_keep_your_disputes")}
        </p>

        <div className="bg-white border border-gray-200 rounded-lg p-8" data-id="element-2634">
          <p className="text-center text-gray-500" data-id="element-2635">{t("pages.VampDetail.no_past_history_found")}</p>
        </div>
      </div>

      {/* Resources */}
      <div data-id="element-2636">
        <h2 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-2637">{t("components.ResourcesSidebar.resources")}</h2>
        <div className="flex flex-wrap gap-4" data-id="element-2638">
          <a href="#" className="flex items-center gap-2 text-sm text-blue-600 hover:text-blue-700" data-id="element-2639">
            
            <ExternalLinkIcon size={14} data-id="element-2640" />
            {t("pages.VampDetail.program_overview")}
          </a>
          <a href="#" className="flex items-center gap-2 text-sm text-blue-600 hover:text-blue-700" data-id="element-2641">
            
            <ExternalLinkIcon size={14} data-id="element-2642" />
            {t("pages.VampDetail.preventing_fraud_and_disputes")}
          </a>
          <a href="#" className="flex items-center gap-2 text-sm text-blue-600 hover:text-blue-700" data-id="element-2643">
            
            <ExternalLinkIcon size={14} data-id="element-2644" />
            {t("pages.VampDetail.preventing_card_testing")}
          </a>
        </div>
      </div>
    </div>;
}